import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClipLoader from "react-spinners/ClipLoader";
import DatePicker from "react-datepicker";
import { getUsers } from '../../actions';
import Table from '../../components/table/table';

import "react-datepicker/dist/react-datepicker.css";
import './users.css';

class Users extends Component {
  state = {
    columns: ['Email', 'Registration Date','Purchase', 'Started Workout'],
    date: new Date('11/1/2020')
  }

  componentWillMount = () => {
    this.props.getUsers(this.state.date);
  }

  componentWillReceiveProps = (nextProps) => {
  }

  byWorkoutElement = (item, i) => (
    <div key={i} className="inline">
      <div className="header"> '{ item.name }' of { item.trainer } :</div> 
      <div className="value"> { item.count } </div>
    </div>
  )

  renderTable = (items, type) => (
    items.sort((a,b) => (a.email > b.email) ? 1 : ((b.email > a.email) ? -1 : 0)).map((item, i) => {
      return this.byUserElement(item, i);
    })
  )

  loader = () => (
    <ClipLoader
              size={15}
              color={"#123abc"}
              loading={true}
            />
  )

  getUsersByDate = (date) => {
    this.setState({
      date
    })

    this.props.getUsers(date);
  }

  render() {
    return (
      <div >
        <DatePicker className="selectDate" selected={this.state.date} onChange={date => this.getUsersByDate(date)} />
        { this.props.users ? 
          <Table columns={this.state.columns} rows={this.props.users.normalauths} />
          : this.loader() 
        }
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    users: state.user.users
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getUsers },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);